module.exports = __webpack_public_path__ + "static/media/SaoPaulo_kmeans_202_100.650908dd.csv";